import { PdsWidget } from '../../pds-widget';
import { MultiSelectField } from '../../models/grid-widget/multi-select-field';
import { MultiSelectFilter } from '../../models/grid-widget/multi-select-filter';
import { MultiSelect } from '../../models/multi-select';
import { MultiSelectItem } from '../../interfaces/multi-select-item';
import { PdsMultiSelectWidget } from '../../pds-multi-select-widget';

export class PdsGwMultiSelectFilter extends PdsWidget {
  is = 'pds-gw-multi-select-filter';

  //Input
  id: string;

  //Input
  filter: MultiSelectFilter;

  //Not an input.
  multiSelect: MultiSelect;

  properties = {
    id: {
      type: String,
      value: null
    },
    filter: {
      observer: 'setInstance',
      value: null
    }
  };

  constructor() {
    super();
  }

  attached(): void {
    super.attached();
    let multiSelectElement: PdsMultiSelectWidget | null = this.querySelector('pds-multi-select-widget') as any;
    if (multiSelectElement != null) {
      multiSelectElement.multiSelect.selectionChange.subscribe((multiSelectItem: MultiSelectItem) => {
        this.filter.searchValues[multiSelectItem.text] = multiSelectItem.isSelected === true;
        this.inputChange();
      });
    }
  }

  checkboxUpdated(event: Event): void {

    let checkbox = (<HTMLInputElement>event.target);
    let id: string | null = checkbox.getAttribute('id');
    if (id != null) {
      this.filter.searchValues[id] = checkbox.checked;
      this.inputChange();
    }
  }

  inputChange(): void {
    this.redrawTrigger = !this.redrawTrigger;
    let event: Event = new Event('renderedElementValueChange', {bubbles: true});
    this.dispatchEvent(event);
  }

  setInstance(filter: MultiSelectFilter): void {
    if (filter == null) {
      return;
    }

    let selectOptions: Array<{key: string, value: boolean}> = (this.filter.dataField as MultiSelectField).selectOptions.array;
    let multiSelectItems: Array<MultiSelectItem> = [];
    for (let selectOption of selectOptions) {
      let selectItem = {
        id: selectOption.key,
        text: selectOption.key,
        isSelected: this.filter.searchValues[selectOption.key]
      };
      multiSelectItems.push(selectItem);
    }
    this.multiSelect = new MultiSelect(multiSelectItems);

    this.multiSelect.selectionChange.subscribe(
      (multiSelectItem: MultiSelectItem) => {
        this.filter.searchValues[multiSelectItem.text] = multiSelectItem.isSelected === true;
        this.inputChange();
      }
    );
  }

  isChecked(item: { key: string }): boolean {
    if (this.filter == null) {
      return false;
    }
    return this.filter.searchValues[item.key];
  }

  filterIsBlank(): boolean {
    return this.filter.isBlank();
  }

  getTagText(): string {
    return this.filter.getTagText();
  }
}
